'use strict';

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

const moveDotsInsideSlider = (slider, destination) => {
    slider.find('.slick-dots').not('.cloned-dots').clone().appendTo(slider.find(destination))
    slider.find(destination).find('.slick-dots').addClass('cloned-dots')
};

const calculateImgHeight = (slider) => {
    var currentImgHeight = slider.find('.slick-current.slick-active img').not('.desktop-img').height();

    if (window.matchMedia('(max-width: 1200px)').matches) {
        slider.find('.slick-arrow').css('height', currentImgHeight)
    }
};

const slickGoto = (slider, index) => {
    slider.slick('slickGoTo', parseInt(index));
};

var Utilites = {
    useMobileView: $(window).outerWidth() <= 768,
    menuFixedACAHandler: function () {
        if ($('.acaPage').length) {
            $('.HPrevamp-header').addClass('isACAPage');
        }
    },

    customSearchFixedHandler: function () {
        if ($('.HPrevamp-header').length) {
            var customSearch = $('.HPrevamp-header #menus-container .navbar-top-categories .custom-search');
            var header = $('header');

            customSearch.css('top', header.outerHeight() + 'px');
        }
    },

    slideOurTrainingHanlder: function () {
        if ($('.section-ourTraining').length) {
            if (Utilites.useMobileView) {
                $('.section-ourTraining').find('.description-training').slick({
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1
                });
            }
        }
    },

    sliderSection5HPHandler: function () {
        if ($('.ACA-component-5').length) {
            $('.ACA-component-5').each(function () {
                var self = $(this);
                var sliderACA = self.find('.ACA-slide');
                var destination_ACA_items = sliderACA.find('.text-content-2');

                sliderACA.find('.ACA-item').each(function () {
                    if ($(this).is(':empty')) {
                        $(this).remove();
                    }
                });

                self.find('.ACA-slide').each(function () {
                    if ($(this).find('.ACA-item').length > 1) {
                        $(this).slick({
                            slidesToShow: 1,
                            centerMode: false,
                            arrows: true,
                            swipe: true,
                            infinite: true,
                            initialSlide: 0,
                            swipeToSlide: true,
                            dots: true,
                            autoplay: false,
                            nextArrow: '<button class="next-arrow"><span class="ACA-arrow"></span></button>',
                            prevArrow: '<button class="prev-arrow"><span class="ACA-arrow"></span></button>'
                        });
                    }
                });

                moveDotsInsideSlider(sliderACA, destination_ACA_items);
                sliderACA.on('afterChange', function (event, slick, currentSlide, nextSlide) { // eslint-disable-line no-unused-vars
                    sliderACA.find(destination_ACA_items).find('.slick-dots').remove();
                    moveDotsInsideSlider(sliderACA, destination_ACA_items);
                    calculateImgHeight(sliderACA);
                });

                $(document).on('click', '.ACA-slide .cloned-dots li', function () {
                    var self = $(this).index();

                    slickGoto(sliderACA, self);
                });
            });
        }
    },

    slidePartnersHanlder: function () {
        if ($('.ACA-component-partners').length) {

            $('.ACA-slide-partners').find('.ACA-item-partners').each(function () {
                if ($(this).is(':empty')) {
                    $(this).remove();
                }
            });

            $('.ACA-component-partners').find('.ACA-slide-partners').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                swipe: true,
                infinite: true,
                initialSlide: 0,
                swipeToSlide: true,
                dots: false,
                autoplay: false,
                nextArrow: '<button class="next-arrow"><span class="ACA-arrow"></span></button>',
                prevArrow: '<button class="prev-arrow"><span class="ACA-arrow"></span></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }]
            });
        }
    },

    sliderLPSection3Handler: function () {
        const sliderAcaLP3 = $('.ACA-slider-cp-3');
        const destinationAcaLP3 = '.ACA-component-text-3';

        if (sliderAcaLP3.length) {
            sliderAcaLP3.find('.ACA-item-cp-3').each(function () {
                if ($(this).is(':empty')) {
                    $(this).remove();
                }
            });

            sliderAcaLP3.slick({
                slidesToShow: 1,
                centerMode: false,
                arrows: true,
                swipe: true,
                infinite: true,
                initialSlide: 0,
                swipeToSlide: true,
                dots: true,
                autoplay: false,
                nextArrow: '<button class="next-arrow"><span class="ACA-arrow"></span></button>',
                prevArrow: '<button class="prev-arrow"><span class="ACA-arrow"></span></button>'
            });
            moveDotsInsideSlider(sliderAcaLP3, destinationAcaLP3)
            sliderAcaLP3.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                sliderAcaLP3.find(destinationAcaLP3).find('.slick-dots').remove()
                moveDotsInsideSlider(sliderAcaLP3, destinationAcaLP3)
                calculateImgHeight(sliderAcaLP3)
            });

            $(document).on('click', '.ACA-slider-cp-3 .cloned-dots li', function () {
                var slideIndex = $(this).index();
                sliderAcaLP3.slick('slickGoTo', parseInt(slideIndex));
            });
        }
    },

    sliderLPsectionProfessorHandler: function () {
        if ($('.section-ourProfessor').length) {

            $('.slide-Professor').find('.professor-item').each(function () {
                if ($(this).is(':empty')) {
                    $(this).remove();
                }
            });

            $('.section-ourProfessor').find('.slide-Professor').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                swipe: true,
                infinite: true,
                initialSlide: 0,
                swipeToSlide: true,
                dots: false,
                autoplay: false,
                nextArrow: '<button class="next-arrow"><span class="ACA-arrow"></span></button>',
                prevArrow: '<button class="prev-arrow"><span class="ACA-arrow"></span></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true
                        }
                    }]
            });
        }
    },

    selectRequestContactUsHandler: function () {
        var selectRequest = $('.select-request');

        if (selectRequest.length) {

            selectRequest.each(function () {
                var $option = $(this).find('option:selected');
                var $value = $option.val();

                if (['request-information', 'updating-profile', 'request-callback', 'others'].includes($value)) {
                    $('.custom-textarea').find('textarea').prop('required',true);
                    if ($('.request-callback-pdp').hasClass('pdp-callback')) {
                        $('.custom-textarea').find('textarea').prop('required',false);
                    } else {
                        $('.custom-textarea').find('textarea').prop('required',true);
                    }
                }
            });

            selectRequest.on('change', function () {
                var $option = $(this).find('option:selected');
                var $value = $option.val();

                if (['request-information', 'updating-profile', 'others'].includes($value)) {
                    $('.request-quote').addClass('d-none');
                    $('.request-callback').removeClass('d-none');
                    $('.request-callback-pdp').addClass('d-none');
                    $('.custom-textarea').find('textarea').prop('required',true);
                    $('#trainingSelection').prop('required',false);
                    $('#sessionSelection').prop('required',false);
                } else if ($value === 'request-quote') {
                    $('.request-quote').removeClass('d-none');
                    $('.request-callback').addClass('d-none');
                    $('.request-callback-pdp').addClass('d-none');
                    $('.custom-textarea').find('textarea').prop('required',false);
                    $('#trainingSelection').prop('required',true);
                    $('#sessionSelection').prop('required',true);
                } else if ($value === 'request-callback') {
                    $('.request-quote').addClass('d-none');
                    if ($('.request-callback-pdp').hasClass('pdp-callback')) {
                        $('.request-callback-pdp').removeClass('d-none');
                        $('.request-callback').addClass('d-none');
                        $('.custom-textarea').find('textarea').prop('required',false);
                        $('#trainingSelection').prop('required',true);
                        $('#sessionSelection').prop('required',true);
                    } else {
                        $('.request-callback').removeClass('d-none');
                        $('.custom-textarea').find('textarea').prop('required',true);
                        $('#trainingSelection').prop('required',false);
                        $('#sessionSelection').prop('required',false);
                    }
                } else {
                    $('.request-quote').addClass('d-none');
                    $('.request-callback').removeClass('d-none');
                    $('.request-callback-pdp').addClass('d-none');
                    $('.custom-textarea').find('textarea').prop('required',true);
                }
            });
        }
    },

    sliderACAstickyBarHandler: function () {
        if ($('.ACA-sticky-menu').length && Utilites.useMobileView) {
            $('.ACA-sticky-menu').slick({
                slidesToShow: 3,
                centerMode: false,
                arrows: false,
                swipe: true,
                infinite: false,
                initialSlide: 0,
                swipeToSlide: true,
                dots: false,
                autoplay: false,
                variableWidth: true,
            });
        }
    },

    redirectFromCountrySelector: function () {
        $('.aca-country-selector').on('click', function () {
            $('.aca-country-menu').toggleClass('d-none');
        });

        $('.aca-country-selector-footer').on('click', function () {
            $('.aca-country-menu-footer').toggleClass('d-none');
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.aca-country-selector').length) {
                $('.aca-country-menu').addClass('d-none');
            }

            if (!$(e.target).closest('.aca-country-selector-footer').length) {
                $('.aca-country-menu-footer').addClass('d-none');
            }
        });

        $('#country-selector-desktop-academy .aca-country-item' || '#country-selector-mobile-academy .aca-country-item').each(function () {
            if ($(this).hasClass('selectedCountry')) {
                $('.selected-language').append($(this).text());
            }

            if ($(this).hasClass('selectedCountry-footer')) {
                $('.selected-language-footer').append($(this).text());
            }
        });

        $('.aca-country-menu, .aca-country-menu-footer').on('click', '.aca-country-item', function () {
            window.location.href = $(this).data('href-option');
        });

    },

    removeFundingOrganizEmptyContentHandler: function () {
        if ($('.funding-organization-content').length) {
            $('.funding-organization-content').find('.funding-organization-item').each(function () {
                if ($(this).is(':empty')) {
                    $(this).remove();
                }
            });
        }
    },

    faqTabsHandler: function () {
        if ($('.faq-coment').length) {
            $('.faq-coment').each(function () {
                $(this).on('click', function () {
                    $(this).toggleClass('show');
                });
            });
        }
    },

    SmoothScrollAnchorLinks: function () {
        var stickyAnchorLink = $('.anchor-link');

        if (stickyAnchorLink.length) {
            stickyAnchorLink.find('a').on('click', function (e) {
                e.preventDefault();
                var target = $($(this).attr('href'));
                var header = $('header').outerHeight();

                if (target.length) {
                    var scrollTo = target.offset().top;
                    
                    $('body, html').animate({ scrollTop: (scrollTo - header) + 'px' }, 800);
                }
            });
        }
    },

    hideImageTitleTxtHandler: function () {
        var imgTitle = $('img');

        if (imgTitle.length) {
            imgTitle.hover(
                function () {
                    $(this).data('title',$(this).attr('title')).removeAttr('title');
                }, 
                function () {
                    $(this).attr('title',$(this).data('title'));
                }
            );
        }
    },

    safariDetectDeviceHandler: function () {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            $('body').addClass('is-safari');
        }
    },

    faqPageHandler: function () {
        var faqACA = $('.faq-aux');

        if (faqACA.length) {
            faqACA.parents('.container').addClass('faq-aca');
        }
    }
}

module.exports = Utilites;

